import React, { useState } from 'react';
import { Leaf, Drumstick, ChevronDown, ChevronUp } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { toast } from 'sonner';

const MenuItemCard = ({ item, darkMode = false }) => {
  const { addToCart } = useCart();
  const [showDescription, setShowDescription] = useState(false);

  const handleAddToCart = (priceIndex = 0) => {
    addToCart(item, priceIndex);
    toast.success(`${item.name} added to order!`, {
      duration: 3000, // 3 seconds
      dismissible: true, // Adds close button
    });
  };

  const getVegIcon = () => {
    if (item.veg === 'veg') {
      return <Leaf size={14} className="text-green-600" />;
    } else if (item.veg === 'non-veg') {
      return <Drumstick size={14} className="text-red-600" />;
    } else if (item.veg === 'both') {
      return (
        <div className="flex gap-1">
          <Leaf size={14} className="text-green-600" />
          <Drumstick size={14} className="text-red-600" />
        </div>
      );
    }
    return null;
  };

  return (
    <div
      className={`rounded-xl p-4 hover:shadow-lg cursor-pointer ${
        darkMode ? 'glass-dark' : 'glass-burgundy'
      }`}
      data-testid={`menu-item-${item.id}`}
      onClick={() => setShowDescription(!showDescription)}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2 flex-1">
          <h3
            className={`text-base font-medium ${
              darkMode ? 'text-gold' : ''
            }`}
            style={!darkMode ? { color: 'var(--burgundy)' } : { color: 'var(--gold)' }}
          >
            {item.name}
          </h3>
          {getVegIcon()}
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold" style={{ color: 'var(--gold)' }}>
            ₹{item.prices_in_inr[0]}
            {item.prices_in_inr.length > 1 && '+'}
          </span>
          {showDescription ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </div>
      </div>

      {showDescription && (
        <>
          <p
            className={`text-xs mb-3 ${
              darkMode ? 'text-cream opacity-80' : ''
            }`}
            style={!darkMode ? { color: 'var(--charcoal)', opacity: 0.8 } : {}}
          >
            {item.description}
          </p>

          <div className="flex flex-wrap gap-2" onClick={(e) => e.stopPropagation()}>
            {item.prices_in_inr.map((price, index) => (
              <button
                key={index}
                onClick={() => handleAddToCart(index)}
                className="px-3 py-1 rounded-full text-xs font-semibold btn-gold"
                data-testid={`add-to-cart-${item.id}-${index}`}
              >
                ₹{price}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default MenuItemCard;